import { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Stack,
  Typography,
  Button,
  CircularProgress,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import { getClientsAccounts } from "../../../services/Admin/AccountsAdminAndUsersApi";
import EditClientAccountDialog from "./EditClientAccountDialog";

const ClintsAccountsPage = () => {
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [error, setError] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [selected, setSelected] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedForEdit, setSelectedForEdit] = useState(null);

  const fetch = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await getClientsAccounts();
      const data = res?.success || res?.status ? res.data : res;
      setClients(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.message || "فشل تحميل حسابات العملاء");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const formatDate = (d) => (d ? new Date(d).toLocaleString() : "-");

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Box>
            <Typography variant="h6">حسابات العملاء</Typography>
            <Typography variant="body2" color="text.secondary">عرض حسابات العملاء</Typography>
          </Box>
          <Button startIcon={<RefreshIcon />} onClick={fetch} disabled={loading} variant="outlined" size="small">
            {loading ? "جارٍ..." : "تحديث"}
          </Button>
        </Stack>

        {loading ? (
          <Box sx={{ py: 6, display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : !clients.length ? (
          <Typography color="text.secondary">لا توجد حسابات</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>الاسم</TableCell>
                  <TableCell>الإيميل</TableCell>
                  <TableCell>الهاتف</TableCell>
                  <TableCell> النوع</TableCell>
                  <TableCell>الحالة</TableCell>
                  <TableCell>تاريخ الإنشاء</TableCell>
                  <TableCell align="center">إجراءات</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clients.map((c) => (
                  <TableRow key={c.id} hover>
                    <TableCell>{c.name}</TableCell>
                    <TableCell>{c.email}</TableCell>
                    <TableCell>{c.phone || "-"}</TableCell>
                    <TableCell>{c.type || "-"}</TableCell>
                    <TableCell>{Number(c.status) === 1 ? "مفعل" : "معطّل"}</TableCell>
                    <TableCell>{formatDate(c.created_at)}</TableCell>
                    <TableCell align="center">
                      <IconButton size="small" onClick={() => { setSelected(c); setOpenDialog(true); }}>
                        <InfoIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedForEdit(c);
                          setOpenEditDialog(true);
                        }}
                        sx={{ ml: 1 }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>تفاصيل الحساب #{selected?.id || ""}</DialogTitle>
        <DialogContent dividers>
          {selected ? (
            <Stack spacing={1}>
              <Typography><strong>الاسم:</strong> {selected.name}</Typography>
              <Typography><strong>البريد:</strong> {selected.email}</Typography>
              <Typography><strong>الهاتف:</strong> {selected.phone || "-"}</Typography>
              <Typography><strong>الدور:</strong> {selected.role || selected.type || "-"}</Typography>
              <Typography><strong>العنوان:</strong> {selected.address || "-"}</Typography>
              <Typography><strong>الحالة:</strong> {Number(selected.status) === 1 ? "مفعل" : "معطّل"}</Typography>
              <Typography><strong>رمز التحقق:</strong> {selected.verification_code || "-"}</Typography>
              <Typography><strong>تاريخ الإنشاء:</strong> {formatDate(selected.created_at)}</Typography>
              <Typography><strong>آخر تعديل:</strong> {formatDate(selected.updated_at)}</Typography>
            </Stack>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>إغلاق</Button>
        </DialogActions>
      </Dialog>

      <EditClientAccountDialog
        open={openEditDialog}
        onClose={() => {
          setOpenEditDialog(false);
          setSelectedForEdit(null);
        }}
        account={selectedForEdit}
        onSuccess={() => {
          setOpenEditDialog(false);
          setSelectedForEdit(null);
          fetch();
        }}
      />
    </Container>
  );
};

export default ClintsAccountsPage;
